import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/bulkTransportOrder/page',
    method: 'get',
    params
  })
}
export function allByOrderId(orderId) {
  return request({
    url: '/api/business/bulkTransportOrder/allByOrderId',
    method: 'get',
    params: {
      orderId
    }
  })
}

export function add(data) {
  return request({
    url: '/api/business/bulkTransportOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/bulkTransportOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/bulkTransportOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/bulkTransportOrder',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOptions(params) {
  return request({
    url: '/api/business/bulkTransportOrder/listOptions',
    method: 'get',
    params
  })
}